<template>
  <div class="card quick-access">
    <div class="card-header">
      <strong>
        {{ card.title }}
      </strong>

      <span class="pull-right label-description" v-if="card.showTotal">
        <!-- Total&nbsp; -->
        <span class="label label-success">
          {{ total }}
        </span>
      </span>
    </div>

    <div class="card-body">
      <table class="table no-margin table-resume">
        <tr>
          <td v-for="d in data">
            <b>
              {{ d.label }}
            </b>
            <br>
            <span :class="`label label-${d.color}`">
              {{ d.value }}
            </span>
          </td>
        </tr>
      </table>
    </div>

    <div class="card-footer" v-if="card.action !== null">
      <a :href="card.link.href"
        :target="card.link.target"
        class="btn btn-white">

        {{ card.action.text }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    card: {
      type: Object,
      required: true
    },

    data: {
      type: Array,
      default () { return [] }
    }
  },

  data () {
    return {
      //
    }
  },

  computed: {
    total () { return this.data.reduce((c, o) => c + (o.value || 0), 0) }
  }
}
</script>

<style media="screen" scoped="" lang="scss">

  .quick-access {

    .card-header {

      .label {
        padding: 3px 10px;
        border-radius: 2px;
      }

      .label-description {
        padding-top: 0px;
      }

    }

    .card-body {
      .label {
        display: inline-block;
        margin-top: 5px;
        padding: 3px 20px;
        border-radius: 2px;
        font-size: 18px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/SimpleCard.vue